/**
 * Lightweight Expo Router history entry. The Learn layout renders the summary itself
 * (`LearnSummaryHost`), above the persistent deck, so Start can hand the screen to the deck at once
 * while the welcome card flies off on top of it.
 */
export function LearnSummaryPage() {
  // eslint-disable-next-line han-page-components/no-blank-page -- History-only leaf; LearnLayout renders the persistent, visible LearnSummaryHost for this route.
  return null;
}
